import React, { useEffect, useState } from "react";
import CustomTable from "../../../components/customTable/CustomTable";
import { useSnackbar } from "notistack";
import TopHeaderComponent from "../../../components/TopHeaderComponent";
import { CustomButton } from "../../../components/customButton/CustomButton";
import {
  EditPen,
  ReportDownload,
  UploadDownload,
} from "../../../resources/assetsManager";
import CustomModal from "../../../components/customModal/CustomModal";
import GenerateReportModalBody from "./GenerateReportModalBody";
import {
  BUTTON_BG_COLOR,
  REPORT_BG_COLOR,
  WHITE_COLOR,
} from "../../../resources/colorsManager";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";
import { SUCCESS } from "../../../resources/constantsManager";
import {
  dateConvert,
  dateConvertNewFormat,
  dateConvertNewFormate,
  formateDate,
} from "../../../../utility/dateModifier";
import ResizeListener from "../../../../utility/ResizeListener";
import { saveAs } from "file-saver";

const ReportContainer = ({ title, createdDate, type, onClickDownload, id }) => {
  const pStyle = {
    fontSize: 15,
    fontWeight: "500",
    fontFamily: "Roboto",
  };
  const lineStyle = {
    marginLeft: 5,
    marginRight: 5,
  };

  return (
    <div
      style={{
        backgroundColor: REPORT_BG_COLOR,
        padding: "25px 10px 25px 30px",
        // border: "1px solid lightgrey",
        borderRadius: 7,
        display: "flex",
        justifyContent: "space-between",
        // flexDirection: width > 930 ? "row" : "column",
        minHeight: 30,
        maxHeight: 60,
        alignItems: "center",
        width: "100%",
        marginBottom: 20,
      }}
      key={id}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <p style={pStyle}>{title}</p>
        <p style={lineStyle}> | </p>
        <p style={pStyle}>{createdDate}</p>
        <p style={lineStyle}> | </p>
        <p style={pStyle}>Type - {type}</p>
      </div>

      <CustomButton
        title="Download"
        isButtonIconRequired={true}
        icon={ReportDownload}
        styles={{
          backgroundColor: WHITE_COLOR,
          border: `1px solid ${BUTTON_BG_COLOR}`,
          borderRadius: 7,
          maxWidth: 150,
          justifyContent: "center",
          alignItems: "center",
          height: 40,
        }}
        textStyles={{
          color: BUTTON_BG_COLOR,
        }}
        onClick={onClickDownload}
      />
    </div>
  );
};
function GeneratedReports() {
  const { enqueueSnackbar } = useSnackbar();
  const [openFilter, setOpenFilter] = useState(false);

  const [showAddReportModal, setShowAddReportModal] = useState(false);
  const [data, setData] = useState("");
  const { height } = ResizeListener();

  const getAllReports = () => {
    ApiRequestGet.getGeneratedReports()
      .then((res) => {
        if (res.status === SUCCESS) {
          setData(res.data);
        } else {
        }
      })
      .catch((err) => {});
  };

  const onClickDownloadReports = (type, date) => {
    ApiRequestGet.reportsDownload(0, data.length, date, type)
      .then((res) => {
        enqueueSnackbar("downloaded successfully", {
          variant: "success",
        });
        saveAs(res, "report.csv");
      })
      .catch((err) => {
        console.log(err);
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      });
  };

  useEffect(() => {
    getAllReports();
  }, []);

  return (
    <div style={{ height: "100%", overflow: "hidden" }}>
      <TopHeaderComponent
        buttonRequired
        headerName="Report Center"
        onClickFilter={() => {
          // setOpenFilter(!openFilter);
          // filterOpened(!openFilter);
        }}
        showDownload={false}
        showFilter={false}
        showDeveloper={
          <CustomButton
            title="Generate New Report"
            styles={{
              border: "none",
              width: "100%",
              borderRadius: 6,
            }}
            icon={EditPen}
            onClick={() => {
              setShowAddReportModal(true);
            }}
          />
        }
        onClickDownload={() => {}}
        disableDownloadIcon={data?.length === 0}
      />

      <div
        style={{
          marginTop: "20px",
          padding: "10px 40px",
          borderRadius: 20,
          minHeight: 500,
          borderBottomLeftRadius: 20,
          borderBottomRightRadius: 20,
          boxSizing: "border-box",
          backgroundColor: WHITE_COLOR,
        }}
      >
        {data && data.length > 0 ? (
          <>
            <div
              style={{
                width: "100%",
                borderBottom: "1px solid #F3F3F3",
                marginBottom: 20,
              }}
            >
              <p
                style={{
                  fontSize: 19,
                  fontWeight: "500",
                }}
              >
                Generated Report History
              </p>
            </div>
            <div
              style={{
                overflow: "scroll",
                height: height * 0.5,
              }}
            >
              {data &&
                data
                  ?.map((res, index) => (
                    <ReportContainer
                      title={`Report ${index + 1}`}
                      createdDate={
                        formateDate(res?.fromDate) +
                        " - " +
                        formateDate(res?.toDate)
                      }
                      type={res?.txnType}
                      onClickDownload={() => {
                        onClickDownloadReports(
                          res?.txnType,
                          `${res?.fromDate}-${res?.toDate}`
                        );
                      }}
                      id={index}
                    />
                  ))
                  ?.reverse()}
            </div>
          </>
        ) : (
          <>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                minHeight: height * 0.6,
              }}
            >
              <p>No Schedulers found</p>
            </div>
          </>
        )}

        {showAddReportModal && (
          <CustomModal
            open={showAddReportModal}
            onClose={() => {
              setShowAddReportModal(false);
            }}
          >
            <GenerateReportModalBody
              onClose={() => {
                setShowAddReportModal(false);
              }}
              onSuccess={() => {
                setShowAddReportModal(false);
                getAllReports();
              }}
            />
          </CustomModal>
        )}
        <div
          style={{
            marginTop: "20px",
            height: openFilter ? "85" : "85%",
          }}
        ></div>
      </div>
    </div>
  );
}

export default GeneratedReports;
